import { ShopCategory } from "../../lang/en/shop/ShopCategory";
import { ShopSubCategory } from "../../lang/en/shop/ShopSubCategory";
import { ShopProduct } from "../../lang/en/shop/ShopProduct";

export const shopEn = {
    shop_category: ShopCategory,
    shop_sub_category: ShopSubCategory,
    shop_product: ShopProduct,
}
